module.exports = "/img/search.svg?f24b352a5a42d68c2a76f8a3b49d54a0";